import React, { createContext } from 'react';
import { InlineComment } from '@amzn/awscat-pattern-library-service-model';

export interface InlineCommentCtxData {
  allInlineComments: InlineComment[];
  setAllInlineComments: React.Dispatch<React.SetStateAction<InlineComment[]>>;
  fetchInlineComments: () => Promise<void>;
}

// @ts-expect-error TS2345 - strict migration
const InlineCommentCtx = createContext<InlineCommentCtxData>(undefined);

export default InlineCommentCtx;
